import styled from 'styled-components';
import { BlackButton, WhiteButton } from '@storefront/lib-global/baseComponents/button';
import { RichTextPartial } from '@storefront/lib-global/partials/richText';
import { TypographyStyles, colours, maxWidthPartial, media, spacing } from '@storefront/lib-global/stylings';

export const StoreLocatorContent = styled.section`
  margin-bottom: ${spacing.M};

  @media ${media.greaterThan('lg')} {
    margin-bottom: 80px;
  }
`;

export const StoreLocatorHeader = styled.h1`
  ${TypographyStyles.Headings.H1}
  ${maxWidthPartial({ withPaddingXL: true })}
      margin: ${spacing.M} 0 20px;
  text-transform: uppercase;
  width: 100%;

  @media ${media.greaterThan('lg')} {
    margin: ${spacing.L} auto ${spacing.M};
  }
`;

export const LocatorContent = styled.div`
  display: flex;
  flex-direction: column;

  @media ${media.greaterThan('lg')} {
    ${maxWidthPartial({ withPaddingXL: true })}
    flex-direction: row;
    gap: 34px;
  }
`;

export const StoreSearchContent = styled.div`
  background-color: ${colours.LIGHT_GREY_2};
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXXXS};
  margin-bottom: 18px;
  padding: 20px ${spacing.S};

  @media ${media.greaterThan('lg')} {
    background-color: unset;
    max-width: 522px;
    min-width: 338px;
    padding: 0;
  }
`;

export const StoreSearchBarSection = styled.div`
  background-color: ${colours.LIGHT_GREY_2};

  @media ${media.greaterThan('lg')} {
    background-color: unset;
  }
`;

export const ErrorMessage = styled.p`
  ${TypographyStyles.Body.Tiny.Regular}
  margin: 0 0 ${spacing.XXXS};

  @media ${media.greaterThan('lg')} {
    margin: ${spacing.XXXXS} 0 ${spacing.XXXS};
  }
`;

export const FindButton = styled(BlackButton)`
  height: 48px;
  margin: 0;
  width: 100%;
`;

export const StoreCardMap = styled.div`
  @media ${media.greaterThan('lg')} {
    display: block;
    margin-bottom: ${spacing.L};
  }
`;

export const StoreCardMapContent = styled.div<{ $isMapViewActive: boolean }>`
  display: ${({ $isMapViewActive }) => ($isMapViewActive ? 'block' : 'none')};
  @media ${media.greaterThan('lg')} {
    display: block;
    flex: 0 1 744px;
  }
`;

export const StoreLocatorContentBodyText = styled(RichTextPartial)`
  display: none;

  @media ${media.greaterThan('lg')} {
    display: block;
    padding: 0;
  }
`;

export const StoreLocatorMobileContentBodyText = styled(RichTextPartial)`
  padding: 0 ${spacing.S};

  @media ${media.greaterThan('lg')} {
    display: none;
  }
`;

export const NoResultsMessage = styled.span<{ $isMapViewActive?: boolean }>`
  ${TypographyStyles.Headings.H5}
  display: flex;
  justify-content: center;
  margin: ${spacing.M} 0;
  margin-top: ${({ $isMapViewActive }) => !$isMapViewActive && 0};
`;

export const StoreLocatorList = styled.ul`
  width: 100%;
`;

export const StoreLocatorListItem = styled.li`
  border: 1px solid ${colours.BLACK};
  width: inherit;
`;

export const LoadMoreButton = styled(WhiteButton)`
  display: block;
  height: 50px;
  justify-content: center;
  margin: 20px auto 0;
  width: 300px;

  @media ${media.lessThan('md')} {
    width: 100%;
  }

  & > svg {
    position: relative;
    right: 5px;
    top: -3px;
  }
`;

export const ResultsContent = styled.section`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: ${spacing.XXXXS};
  padding: 0 ${spacing.S};

  @media ${media.greaterThan('lg')} {
    max-width: 522px;
    min-width: 338px;
    padding: 0;
  }
`;

export const ResultsList = styled.ul<{ $isListViewActive: boolean }>`
  display: ${({ $isListViewActive }) => ($isListViewActive ? 'flex' : 'none')};
  flex-direction: column;
  gap: ${spacing.XXS};
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;

  @media ${media.greaterThan('lg')} {
    display: flex;
  }
`;

export const ResultsTabContainer = styled.div`
  align-items: center;
  display: flex;
  height: 32px;
  justify-content: space-between;
  margin-bottom: ${spacing.M};
  width: 100%;
  span {
    ${TypographyStyles.Body.Tiny.SemiBold}
  }
  @media ${media.greaterThan('lg')} {
    margin-bottom: ${spacing.XS};
  }
`;

export const TabSwitcher = styled.div`
  border-bottom: 2px solid ${colours.BLACK};
  display: flex;
  gap: ${spacing.XXS};
  height: 100%;
`;

export const TabSwitcherButton = styled.button<{ $isActive: boolean }>`
  align-items: center;
  background: none;
  border: none;
  border-bottom: ${({ $isActive }) => $isActive && `2px solid ${colours.BLACK}`};
  color: ${colours.BLACK};
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 5px;
  ${({ $isActive }) => ($isActive ? TypographyStyles.Body.Small.SemiBold : TypographyStyles.Body.Small.Regular)}
`;

export const FocusedMapViewStoreItem = styled.ul`
  margin: ${spacing.S};
  padding: 0;

  @media ${media.greaterThan('lg')} {
    margin-top: ${spacing.M};
  }
`;

export const StoreListSection = styled.section`
  display: flex;
  flex: 1 1;
  flex-direction: column;
  gap: ${spacing.XXXXS};

  @media ${media.greaterThan('lg')} {
    max-width: 522px;
    min-width: 338px;
    padding: 0;
  }
`;
